import React from 'react'
import * as T from '../../../components/Table'
import { Link } from 'react-router-dom'
import { Text } from '@chakra-ui/react'

export const ValidacaoCaricaturaItem = ({ numero_pedido, total_produto, nome_cliente, numero_nota, prazo_producao }) => {
  return (
    <T.Tr>
      <T.Td cursor="pointer">
        <Text display="block" as={Link} w="100%" to={`/arte-final/validacao-de-caricatura/${numero_nota}`}>
          {numero_pedido}
        </Text>
      </T.Td>
      <T.Td cursor="pointer">
        <Text as={Link} w="100%" display="block" to={`/arte-final/validacao-de-caricatura/${numero_nota}`}>
          {total_produto}
        </Text>
      </T.Td>
      <T.Td cursor="pointer">
        <Text as={Link} w="100%" display="block" to={`/arte-final/validacao-de-caricatura/${numero_nota}`}>
          {nome_cliente}
        </Text>
      </T.Td>
      <T.Td cursor="pointer">
        <Text as={Link} w="100%" display="block" to={`/arte-final/validacao-de-caricatura/${numero_nota}`}>
          {`${prazo_producao} Dias`}
        </Text>
      </T.Td>
    </T.Tr>
  )
}
